export default {
  init() {
    const eventTypes = $('.event-type');

    eventTypes.on('click', function () {
      const descriptionContainer = $(this).parent('.event-type-row').find('.event-type-description-container');
      var description = $(this).find('.event-type-description'),
          descriptionClone = description.clone();

      if( $(this).hasClass('is--active') ) {
        $(this).removeClass('is--active');
        descriptionContainer.empty();
        descriptionContainer.removeClass('is--toggled');
      } else {
        $('.event-type.is--active').removeClass('is--active');
        $('.event-type-description-container.is--toggled').empty();
        $('.event-type-description-container.is--toggled').removeClass('is--toggled');

        $(this).addClass('is--active');
        descriptionContainer.addClass('is--toggled');
        descriptionContainer.append(descriptionClone);
      }
    });
  }
}
